import { createAction } from '@reduxjs/toolkit';
import type { AppThunk } from '../store/configureStore';

export const OPEN_SIDEBAR = createAction<void>('OPEN_SIDEBAR');
export const CLOSE_SIDEBAR = createAction<void>('CLOSE_SIDEBAR');

export const openSidebar = (): AppThunk => (dispatch) => {
  dispatch(OPEN_SIDEBAR());
};

export const closeSidebar = (): AppThunk => (dispatch) => {
  dispatch(CLOSE_SIDEBAR());
};
